import Stats from "./stats.atom";

export default Stats;
